/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.drawsParticipations.internal

import features.drawsParticipations.models.ParticipationsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class DrawsParticipationsRequest : NetworkRequest() {

    suspend fun getDrawsParticipations(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<ParticipationsModel> {
        return safeNetworkCall {
            get(
                endpoint = DrawsParticipationsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
